import sendCurriculumMutation from '../mutations/SendCurriculum.gql'
import fetchSentCurriculums from '../queries/FetchSentCurriculums.gql'

export default function (variables) {
  return {
    mutation: sendCurriculumMutation,
    variables: variables,
    refetchQueries: [
      {
        query: fetchSentCurriculums,
        variables: { id: variables.studentId },
      },
    ],
  }
}
